/* v8 ignore start */
// Actions
import { createSlice } from '@reduxjs/toolkit';
export const namespace = 'exampleWizards/complexWizard';
const initialState = () => ({
  isOpen: true,
  nextDisabled: true,
  selectedRadio: null,
  selectedPath: null,
});

const complaexWizardSlice = createSlice({
  name: 'exampleWizards/complexWizard',
  initialState,
  reducers: {
    handleOpen: () => initialState(),
    handleClose: state => ({ ...state, isOpen: false }),
    handlePath: (state, {payload}) => ({ ...state, selectedRadio: payload, nextDisabled: false }),
    selectPath: state => ({ ...state, selectedPath: state.selectedRadio }),
    resetPath: state => ({ ...state, selectedPath: null })
  }
});

const { actions, reducer } = complaexWizardSlice;
export default reducer;
export const { handleOpen, handleClose, handlePath, selectPath, resetPath } = actions;
